module.exports = __webpack_public_path__ + "img/howto@2x.74847c23.png";